import banner from "../../../assets/images/banner-blue.png";

export default function Banner() {
  return (
    <div className="flex justify-center items-center bg-karimjee">
      <img src={banner} alt="" className="w-2/4" />
    </div>
  );
}
